import "core-js/modules/es.array.push.js";
import "core-js/modules/es.iterator.constructor.js";
import "core-js/modules/es.iterator.some.js";
import "core-js/modules/es.object.to-string.js";
import "core-js/modules/es.regexp.to-string.js";
import "core-js/modules/es.string.trim.js";
/**
 * Vue2 Element UI表格拖动与选择指令
 * 功能：
 * 1. 在表格空白区域可左右拖动表格
 * 2. 在单元格(.cell)上显示文本选择光标
 * 3. 在单元格上禁用拖动功能，允许文本选择
 * 4. 支持单元格点击复制功能
 * 5. 支持鼠标移动时光标自动切换
 */

import Vue from 'vue';

// 指令定义对象
var tableDragSelectDirective = {
  // 指令绑定时的初始化逻辑
  bind: function bind(el, binding, vnode) {
    var odiv = el; // 获取当前表格元素
    var mouseDownAndUpTimer = null;
    var mouseOffset = 0;
    var mouseFlag = false;
    var isOverCell = false; // 标记鼠标是否在cell元素上
    var scrollContainer = null;

    // 获取配置参数
    var config = binding.value || {};
    var tableRef = config.tableRef || 'orderTable';
    var enableClickCopy = config.enableClickCopy !== false;
    var dragSensitivity = config.dragSensitivity || 1.5;

    // 查找滚动容器
    var findScrollContainer = function findScrollContainer() {
      return el.querySelector('.el-table .el-table__body-wrapper');
    };

    // 递归查找包含指定类的元素
    var findParentWithClass = function findParentWithClass(element, className) {
      while (element && element !== document) {
        if (element.classList && element.classList.contains(className)) {
          return element;
        }
        element = element.parentNode;
      }
      return null;
    };

    // 检查事件目标是否在cell元素内
    var isInCell = function isInCell(target) {
      return findParentWithClass(target, 'cell') !== null;
    };

    // 获取事件路径（兼容性处理）
    var composedPath = function composedPath(e) {
      if (e.path) {
        return e.path;
      }
      var target = e.target;
      e.path = [];
      while (target.parentNode !== null) {
        e.path.push(target);
        target = target.parentNode;
      }
      e.path.push(document, window);
      return e.path;
    };

    // 鼠标按下事件
    var mouseDownHandler = function mouseDownHandler(e) {
      var ePath = composedPath(e);

      // 拖拽表头不滑动
      if (ePath.some(function (res) {
        return res && res.className && (res.className.indexOf('el-table__header') > -1 || res.className.indexOf('cell') > -1 && isOverCell);
      })) return;
      if (e.which !== 1) return;

      // 如果鼠标在cell上，不触发拖动
      if (isOverCell) {
        return;
      }
      mouseOffset = e.clientX;
      mouseDownAndUpTimer = setTimeout(function () {
        mouseFlag = true;
        if (scrollContainer) {
          scrollContainer.style.cursor = 'grabbing';
        }
      }, 80);
    };

    // 鼠标抬起事件
    var mouseUpHandler = function mouseUpHandler(e) {
      if (mouseFlag) {
        mouseFlag = false;
        if (scrollContainer) {
          // 根据是否在cell上恢复光标
          scrollContainer.style.cursor = isOverCell ? 'text' : 'grab';
        }
      } else {
        clearTimeout(mouseDownAndUpTimer);
      }

      // 重新布局表格
      setTimeout(function () {
        vnode.context.$refs[tableRef] && vnode.context.$refs[tableRef].doLayout();
      }, 200);
    };

    // 鼠标离开表格区域
    var mouseLeaveHandler = function mouseLeaveHandler(e) {
      if (mouseFlag) {
        mouseFlag = false;
        if (scrollContainer) {
          scrollContainer.style.cursor = 'grab';
        }
      }
      setTimeout(function () {
        vnode.context.$refs[tableRef] && vnode.context.$refs[tableRef].doLayout();
      }, 200);
    };

    // 鼠标移动事件
    var mouseMoveHandler = function mouseMoveHandler(e) {
      if (e.which !== 1) return;

      // 检查是否在cell上移动
      var currentIsOverCell = isInCell(e.target);

      // 如果状态发生变化，更新光标
      if (currentIsOverCell !== isOverCell) {
        isOverCell = currentIsOverCell;
        if (scrollContainer) {
          scrollContainer.style.cursor = isOverCell ? 'text' : mouseFlag ? 'grabbing' : 'grab';
        }
      }

      // 如果在cell上，不执行拖动
      if (isOverCell) return;
      if (mouseFlag && scrollContainer) {
        var newOffset = e.clientX;
        var delta = mouseOffset - newOffset;
        mouseOffset = newOffset;

        // 设置水平滚动
        scrollContainer.scrollLeft += delta * dragSensitivity;
      }
    };

    // 全局鼠标移动事件，用于检测鼠标是否在cell上
    var globalMouseMoveHandler = function globalMouseMoveHandler(e) {
      var currentIsOverCell = isInCell(e.target);
      if (currentIsOverCell !== isOverCell) {
        isOverCell = currentIsOverCell;
        if (scrollContainer) {
          if (!mouseFlag) {
            // 只有在没有拖动时更新光标
            scrollContainer.style.cursor = isOverCell ? 'text' : 'grab';
          }
        }
      }
    };

    // 点击事件 - 处理单元格复制
    var clickHandler = function clickHandler(e) {
      var cellElement = findParentWithClass(e.target, 'cell');
      if (cellElement && !mouseFlag && enableClickCopy) {
        // 获取单元格文本
        var cellText = cellElement.textContent || cellElement.innerText;

        // 如果有选中的文本，优先使用选中的文本
        var selection = window.getSelection();
        var selectedText = selection.toString().trim();
        if (selectedText) {
          // 复制选中的文本
          // copyToClipboard(selectedText)
        } else if (cellText) {
          // 复制整个单元格内容
          // copyToClipboard(cellText)
        }
      }
    };

    // 复制到剪贴板
    var copyToClipboard = function copyToClipboard(text) {
      var textArea = document.createElement('textarea');
      textArea.value = text;
      textArea.style.position = 'fixed';
      textArea.style.left = '-999999px';
      textArea.style.top = '-999999px';
      document.body.appendChild(textArea);
      textArea.select();
      try {
        document.execCommand('copy');
      } catch (err) {
        console.error('复制失败:', err);
      }
      document.body.removeChild(textArea);
    };

    // 显示消息
    var showMessage = function showMessage(message) {
      if (vnode.context && vnode.context.$message) {
        vnode.context.$message.success(message);
      } else if (window.console && window.console.log) {
        console.log(message);
      }
    };

    // 防止默认拖拽行为
    var dragStartHandler = function dragStartHandler(e) {
      e.preventDefault();
    };
    var dragEndHandler = function dragEndHandler(e) {
      e.preventDefault();
    };

    // 监听表格内部变化，重新获取滚动容器
    var observer = new MutationObserver(function () {
      scrollContainer = findScrollContainer();
      if (scrollContainer) {
        scrollContainer.style.cursor = isOverCell ? 'text' : 'grab';
      }
    });

    // 开始观察表格DOM变化
    if (el.querySelector('.el-table')) {
      observer.observe(el.querySelector('.el-table'), {
        childList: true,
        subtree: true
      });
    }

    // 初始化滚动容器
    scrollContainer = findScrollContainer();
    if (scrollContainer) {
      scrollContainer.style.cursor = 'grab';
    }

    // 绑定事件
    odiv.addEventListener('mousedown', mouseDownHandler);
    odiv.addEventListener('mouseup', mouseUpHandler);
    odiv.addEventListener('mouseleave', mouseLeaveHandler);
    odiv.addEventListener('mousemove', mouseMoveHandler);
    document.addEventListener('mousemove', globalMouseMoveHandler);
    odiv.addEventListener('dragstart', dragStartHandler);
    odiv.addEventListener('dragend', dragEndHandler);
    odiv.addEventListener('click', clickHandler);

    // 存储事件处理函数，以便在unbind时移除
    el._tableDragSelectHandlers = {
      mouseDownHandler: mouseDownHandler,
      mouseUpHandler: mouseUpHandler,
      mouseLeaveHandler: mouseLeaveHandler,
      mouseMoveHandler: mouseMoveHandler,
      globalMouseMoveHandler: globalMouseMoveHandler,
      dragStartHandler: dragStartHandler,
      dragEndHandler: dragEndHandler,
      clickHandler: clickHandler
    };
    el._tableDragSelectObserver = observer;
    el._tableDragSelectConfig = config;
  },
  // 指令更新时的逻辑
  update: function update(el, binding, vnode) {
    // 更新配置
    el._tableDragSelectConfig = binding.value || {};
  },
  // 指令解绑时的清理逻辑
  unbind: function unbind(el) {
    var handlers = el._tableDragSelectHandlers;
    var observer = el._tableDragSelectObserver;
    if (handlers) {
      el.removeEventListener('mousedown', handlers.mouseDownHandler);
      el.removeEventListener('mouseup', handlers.mouseUpHandler);
      el.removeEventListener('mouseleave', handlers.mouseLeaveHandler);
      el.removeEventListener('mousemove', handlers.mouseMoveHandler);
      document.removeEventListener('mousemove', handlers.globalMouseMoveHandler);
      el.removeEventListener('dragstart', handlers.dragStartHandler);
      el.removeEventListener('dragend', handlers.dragEndHandler);
      el.removeEventListener('click', handlers.clickHandler);
    }
    if (observer) {
      observer.disconnect();
    }

    // 清理引用
    delete el._tableDragSelectHandlers;
    delete el._tableDragSelectObserver;
    delete el._tableDragSelectConfig;
  }
};

// 创建插件对象
var TableDragSelectPlugin = {
  install: function install(Vue) {
    Vue.directive('table-drag-select', tableDragSelectDirective);
  }
};

// 全局注册指令
Vue.directive('table-drag-select', tableDragSelectDirective);

// 导出插件
export default TableDragSelectPlugin;

// 导出指令对象
export { tableDragSelectDirective };